/*
 * Copyright (c) TIKI Inc.
 * MIT license. See LICENSE file in root directory.
 */

import { authenticatedFetch } from "@shopify/app-bridge-utils";
import { useAppBridge } from "@shopify/app-bridge-react";
import { AppBridgeState, ClientApplication } from "@shopify/app-bridge";
import { Redirect } from "@shopify/app-bridge/actions";

export function useAuthenticatedFetch() {
  const app = useAppBridge();
  const fetchFunction = authenticatedFetch(app);

  return async (uri: string, options?: RequestInit) => {
    const response = await fetchFunction(uri, options);
    checkHeadersForReauthorization(response.headers, app);
    return response;
  };
}
  
function checkHeadersForReauthorization(headers: Headers, app: ClientApplication<AppBridgeState>) {
    if (headers.get("X-Shopify-API-Request-Failure-Reauthorize") === "1") {
        const authUrlHeader =
        headers.get("X-Shopify-API-Request-Failure-Reauthorize-Url") ||
        `/api/auth`;

        const redirect = Redirect.create(app);
        redirect.dispatch(
        Redirect.Action.REMOTE,
        authUrlHeader.startsWith("/")
            ? `https://${window.location.host}${authUrlHeader}`
            : authUrlHeader
        );
    }
}